import { DataProvider } from "@refinedev/core";
import nestjsxCrudDataProvider from "@refinedev/nestjsx-crud";

export const dataProvider = (axiosInstance: any): DataProvider => {
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

  return nestjsxCrudDataProvider(API_URL, axiosInstance);
};